import { defineStore } from 'pinia';
import {
  computed,
  toRef,
} from 'vue';

import { useConfigQuery } from '@modules/config/queries';
import useI18nStore from '@modules/i18n/store/useI18nStore';
import { usePermissionsQuery } from '@modules/permissions/queries';
import { usePermissionsStore } from '@modules/permissions/store';
import { useTokensQuery } from '@modules/tokens/queries';

const useAppStore = defineStore('app', () => {
  const { data: token } = useTokensQuery();
  usePermissionsQuery();
  const permissions = toRef(usePermissionsStore(), 'permissions');
  const { data: config } = useConfigQuery();
  const localizationStore = useI18nStore();

  const isAppReady = computed(() => (
    !!config.value && !!token.value && !!permissions.value && localizationStore.isInitialized
  ));

  return { isAppReady };
});

export default useAppStore;
